import { ActionCardModel } from '@playbooks/action-cards-utils/src'
import { ActionCard, Section } from '@playbooks/core/src/interfaces/ActionCard'

function getRequitedNotFilledFieldIds(sections: Section[], conditionalItems: number[]) {
  return (
    new ActionCardModel({ sections, conditionalItems } as ActionCard)
      .getSearchService()
      .filterRequired()
      .filterVisible()
      .filterEmptyInputNodes()
      .map(field => (field.data as { id: string }).id) || []
  )
}

export default getRequitedNotFilledFieldIds
